import { Component } from '@angular/core';

@Component({
  selector: 'spark-lending-partner-program',
  templateUrl: './lending-partner-program.component.html',
  styleUrls: ['./lending-partner-program.component.scss']
})
export class LendingPartnerProgramComponent {
  constructor() {}

  public lendingPartnerLogos = [
    "logo_activepipe.png",
    "logo_ali.png",
    "logo_allianz.png",
    "logo_amp.png",
    "logo_anz.png",
    "logo_astute.png",
    "logo_bankwest.png",
    "logo_bendigo.png",
    "logo_bankofmelbourne.png",
    "logo_boq.png",
    "logo_cba.png",
    "logo_citoplus.png",
    "logo_depositassure.png",
    "logo_depositpower.png",
    "logo_finquick.png",
    "logo_ing.png",
    "logo_liberty_nmb_panel.png",
    "logo_macquarie.png",
    "logo_mebank.png",
    "logo_money-place.png",
    "logo_moula.png",
    "logo_nab.png",
    "logo_nfal.png",
    "logo_nfc.png",
    "logo_paramount.png",
    "logo_peppermoney.png",
    "logo_redzed.png",
    "logo_stgeorge.png",
    "logo_suncorp.png",
    "logo_teachersmutual.png",
    "logo_westpac.png"];
}
